module.exports = __webpack_public_path__ + "media/images/icons/calendar-e7b591bfd399f31e275c19567fd0de0a.svg";